// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/ActiveTab/Images/Content/Content/Content/Comparison/Content/Content/Actions/Choose/ImageSelect/Content/Content/Images/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_TreatmentCard_Content_TreatmentCard_Images_ActiveTab_Images_Content_Content_Content_Comparison_Content_Content_Actions_Choose_ImageSelect_Content_Content_Images($image_series_id: numeric!) {
  vaxiom_patient_images(
    where: { imageseries_id: { _eq: $image_series_id } }
    order_by: { order: asc }
  ) {
    id
    file_key
    original_file_key
    type_key
    slot_key
  }
}

`